export const BIRTH_DATE_MAXIMUM = 18;
export const CAPTCHA_ERROR = 'captcha';
export const MAX_FILE_COUNT = 4;
export const MAX_FILE_SIZE = '4mb';
export const ACCEPTED_FILE_FORMATS = '.jpg, .png, .jpeg';
